import Vue from 'vue'
import { Button, Select, Option, Tabs, TabPane,
         Input, Form, FormItem, Radio, RadioGroup,
         Checkbox, CheckboxGroup, Dropdown, DropdownItem,
         DropdownMenu, Menu, MenuItem, Submenu, Message,
         Row, Col, MessageBox,DatePicker, Slider, Dialog,
         TimeSelect, Paginatino, Pagination, Upload} from 'element-ui'


Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Row)
Vue.use(Col)
Vue.use(Slider)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(TimeSelect)
Vue.use(Pagination)
Vue.use(Upload)


Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message